import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import KeyMetadataModal from './components/KeyMetadataModal';
import { hasKeysTag } from './utils/keysTag';
export default function addKeyMetadataComposer() {
  // Mirrors champis-events' addEventComposer.js. No canEditKeyMetadata()
  // check here: a brand new discussion has no author yet distinct from the
  // actor creating it, so anyone who can start a discussion in this
  // category can fill in its key info.
  extend('flarum/forum/components/DiscussionComposer', 'headerItems', function (items) {
    const tags = this.composer.fields.tags || [];
    if (!hasKeysTag(tags)) return;
    items.add('keyMetadata', m(Button, {
      icon: "fas fa-info-circle",
      onclick: () => app.modal.show(KeyMetadataModal, {
        initialMetadata: this.composer.fields.keyMetadata,
        onsubmit: keyMetadata => {
          this.composer.fields.keyMetadata = keyMetadata;
        }
      })
    }, app.translator.trans('champis-keys.forum.key_metadata.control_button')));
  });
  extend('flarum/forum/components/DiscussionComposer', 'data', function (data) {
    if (this.composer.fields.keyMetadata) {
      data.keyMetadata = this.composer.fields.keyMetadata;
    }
  });
}